//// validateArticle.js
//const validate = (values, props) => {
//    const errors = {};
//    const requiredFields = ['type', 'title'];

//    const { t } = props; // Destructure the translation function

//    requiredFields.forEach(field => {
//        if (!values[field]) {
//            errors[field] = t('fieldRequired'); // Now using translated message
//        }
//    });

//    return errors;
//};

//export default validate;


//import i18n from "i18next";

//const validate = (values) => {
//    const errors = {};
//    const requiredFields = ['type', 'title'];

//    requiredFields.forEach(field => {
//        if (!values[field]) {
//            errors[field] = i18n.t('fieldRequired'); // Translate here
//        }
//    });

//    return errors;
//};

//export default validate;


//const validateArticle = (values) => {
//    const errors = {};
//    const requiredFields = ['type', 'title'];

//    requiredFields.forEach(field => {
//        if (!values[field]) {
//            errors[field] = 'validation.fieldRequired'; // Use a key instead of translation
//        }
//    });

//    return errors;
//};

//export default validateArticle;

//const validate = (t) => (values) => {
//    const errors = {};
//    const requiredFields = ['type', 'title'];
//    requiredFields.forEach(field => {
//        if (!values[field]) {
//            errors[field] = t('fieldRequired'); // Use a key for translation
//        }
//    });
//    //if (!values.title) {
//    //    errors.title = t('title'); // Key from your i18n JSON
//    //}

//    //if (!values.type) {
//    //    errors.type = t('type');
//    //}

//    // Add other field validations here...

//    return errors;
//};

//export default validate;

const validate = (values) => {
    const errors = {};
    const requiredFields = ['type', 'title', "titleEn"];

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'fieldRequired'; // Use a key instead of translation
        }
    });

    return errors;
};

export default validate;
